import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import { format, isValid } from 'date-fns';
import MonthSelectorInput from '../../../date/MonthSelectorInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MonthSelectorFormField',
  props: makeUseFormElementProps<FieldModel, string>(),
  emits: makeUseFormElementEmits<string>(),
  setup(__props, { emit }) {

const props = __props;





const date = ref<Date | undefined>(new Date());

const formElement = useFormElement({
  emit,
  props,
});

const { placeholder, inputClass, inputErrorClass, fieldErrorsShown } = useBaseFieldValues(formElement);

const { modelStateRef, field, setValue } = formElement;

const inputGroupClass = modelStateRef('inputGroupClass', '');

function onInputChange(value: Date) {
  setValue(format(value, 'yyyy-MM-dd'));
}

function onDismiss() {
  field.value.$touch();
}

watch(
  () => field.value.$model,
  () => {
    if (!field.value.$model) {
      date.value = undefined;
    } else {
      const dateVal = new Date(field.value.$model);
      if (field.value.$model && isValid(dateVal)) {
        date.value = dateVal;
      } else {
        date.value = undefined;
      }
    }
  },
  { immediate: true }
);

return { __sfc: true,props, emit, date, formElement, placeholder, inputClass, inputErrorClass, fieldErrorsShown, modelStateRef, field, setValue, inputGroupClass, onInputChange, onDismiss, MonthSelectorInput }
}

})